module.exports = __webpack_public_path__ + "img/EmptyProduct.745f5d90.svg";